import React from "react";

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import "antd/dist/antd.min.css";

import "./antd-theme/antd-customized.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
